import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { KompaktdarstellungTemplateComponent } from '../kompakt-darstellung-template.component';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { NgTemplateOutlet, PlatformLocation } from '@angular/common';
import { ComponentLocationStrategy } from '../../services/location-strategy/component-location-strategy';
import { GeometergeschaeftTimePoint } from '../../../core/av-api';
import { LinkComponent, NavTarget } from '../../components/link/link.component';
import { FormatGeometergeschaeftsnummerPipe } from '../../pipes/format/format-geometergeschaeftsnummer.pipe';

@Component({
  selector: 'cap-kompakt-geometergeschaeft',
  templateUrl: './kompakt-geometergeschaeft.component.html',
  styleUrls: ['./kompakt-geometergeschaeft.component.scss'],
  imports: [NgTemplateOutlet, LinkComponent, FormatGeometergeschaeftsnummerPipe]
})
export class KompaktGeometergeschaeftComponent extends KompaktdarstellungTemplateComponent {
  navTargets = NavTarget;

  @Input() item: GeometergeschaeftTimePoint;

  @Input()
  canViewGeoGeschaeftDetails = true;

  @ViewChild('typ00', { static: true }) typ00Template: TemplateRef<any>;

  constructor(formatService: FormatConfigService, location: PlatformLocation, locationStrategy: ComponentLocationStrategy) {
    super(formatService, 'GEOMETERGESCHAEFT', location, locationStrategy);
  }

  getDefaultTemplate(): TemplateRef<any> {
    return this.typ00Template;
  }

  registerTemplates() {
    this.bindTemplates(this.typ00Template, 'GEOMETERGESCHAEFT_TYP00');
  }
}
